import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import "fontsource-muli";
import Color from "../../../utils/Color";

export const getFontSize = (size) => {
  switch (size) {
    case "xxsmall":
      return { fontSize: 12 };
    case "xsmall":
      return { fontSize: 13 };
    case "small":
      return { fontSize: 14 };
    case "medium":
      return { fontSize: 16 };
    case "large":
      return { fontSize: 18 };
    case "xlarge":
      return { fontSize: 20 };
    case "xxlarge":
      return { fontSize: 22 };
    case "xxxlarge":
      return { fontSize: 24 };
    case "xxxxlarge":
      return { fontSize: 30 };
    default:
      return getFontSize("small");
  }
};

export const getFontWeight = (size) => {
  switch (size) {
    case "400":
      return { fontWeight: "400" };
    case "normal":
      return { fontWeight: "normal" };
    case "600":
      return { fontWeight: "600" };
    case "bold":
      return { fontWeight: "bold" };
    case "800":
      return { fontWeight: "800" };
    case "1000":
      return { fontWeight: "1000" };
    default:
      return getFontWeight("normal");
  }
};

const CustomText = ({ classes, ...props }) => {
  const { children, design } = props;
  return (
    <Typography className={`${classes.root} ${design}`} {...props}>
      {children}
    </Typography>
  );
};
const styles = {
  root: {
    color: Color.primaryTextColor,
    fontSize: 14,
    fontWeight: "bold",
    fontFamily: "Muli",
    letterSpacing: "normal",
    lineHeight: "1.24",
    fontStretch: "normal",
    fontStyle: "normal",
  },
};
export default withStyles(styles)(CustomText);
